export const leftPanelActions = (state, dispatch, props) => {
  function updateLeftPanel(leftPanelData) {
    dispatch({ type: "LEFTPANEL_UPDATE", payload: leftPanelData });
  }

  return {
    updateLeftPanel,
  };
};
